import React from 'react';
import { IconButton, Paper, makeStyles, colors } from '@material-ui/core';
import { Person } from '@material-ui/icons';

import CompressedButtonMenu from './CompressedButtonMenu';

const useStyles = makeStyles({
  root: {
    height: 64,
    width: 64,
    borderRadius: 32,
  },
  button: {
    height: 64,
    width: 64,
    borderRadius: 32,
    color: colors.grey[50],
    backgroundColor: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const CompressedButton = () => {
  const classes = useStyles();

  return (
    <CompressedButtonMenu
      renderButton={(onClick) => (
        <Paper elevation={3} className={classes.root}>
          <IconButton className={classes.button} onClick={onClick}>
            <Person style={{ fontSize: 32 }}></Person>
          </IconButton>
        </Paper>
      )}
    ></CompressedButtonMenu>
  );
};

export default CompressedButton;
